
enum ScrollDirection{
  Up,
  Down
}

export const findTopMostVisible =
(
  updates: IntersectionObserverEntry[],
  nextUpdate: IntersectionObserverEntry[],
  previousUpdate: IntersectionObserverEntry[]
)=> {

    let scrollDirection = ScrollDirection.Down;
    const current = updates[0];
    const previous = previousUpdate && previousUpdate.find(p => p.target.id === current.target.id);
    const exitsUpwards = el => el.intersectionRect.bottom < el.rootBounds?.height && !el.isIntersecting;

    if(!previousUpdate){
      // First invocation, select the topmost visible
      return updates.find(u => u.isIntersecting);
    }

    if(previous){
      scrollDirection = current.boundingClientRect.top <= previous.boundingClientRect.top ? ScrollDirection.Down : ScrollDirection.Up;
    }

    if(scrollDirection === ScrollDirection.Down && exitsUpwards(current)){
      const indexOfHidden = nextUpdate.findIndex(x => x.target === current.target);
      return nextUpdate.find((u, i) => i > indexOfHidden && u.isIntersecting );
    }
    const currentIndex = nextUpdate.findIndex(x => x.target === current.target);
    return currentIndex > 0 ? nextUpdate.find((u,i) => i < currentIndex && u.isIntersecting) : current;
};

/**
 * Returns the DOM element id of the observed target matched by the findPredicate
 *
 * @param callback callback function invoked when the matched DOM target element is found
 * @param findPredicate defaults to findTopMostVisible
 */
export const activeIdSelector = (callback: (id: number) => void, findPredicate = findTopMostVisible) =>
(
  updates: IntersectionObserverEntry[],
  nextUpdate: IntersectionObserverEntry[],
  previousUpdate: IntersectionObserverEntry[]
) => {

  const active = findPredicate(updates,nextUpdate, previousUpdate);
  active && active.target && callback( Number(active.target.id) );
  return active;
};
